import { getTheme, concatStyleSets } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var defaultStyles = function (theme) {
    return {
        root: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: "transparent",
            selectors: {
                "&.hidden": {
                    top: -1,
                    left: -1,
                    width: 0,
                    height: 0,
                    overflow: "hidden"
                }
            }
        },
        overlay: {
            selectors: {
                "&.hsplit": {
                    cursor: "ew-resize"
                },
                "&.vsplit": {
                    cursor: "ns-resize"
                }
            }
        },
        content: {
            position: "absolute",
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        }
    };
};
var StyleConfig = {
    defaultStyles: defaultStyles
};
var getStyles = memoizeFunction(function (theme, customStyles) {
    return concatStyleSets(StyleConfig.defaultStyles(theme || getTheme()), customStyles);
});
export { getStyles, StyleConfig };
